import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Home from '@/views/Home.vue'
import Detail from '@/views/Detail.vue'
import Conditions from '@/views/Conditions.vue'
import QRLogin from '@/views/register/QRLogin.vue'
import Register from '@/views/Register.vue'
import Login from '@/views/register/Login.vue'
import Welcome from '@/views/register/Welcome.vue'
import NotMe from '@/views/register/NotMe.vue'
import Steps from '@/views/register/Steps.vue'
import Identity from '@/views/register/Identity.vue'
import Request from '@/views/register/Request.vue'
import PhotoUpload from '@/views/register/PhotoUpload.vue'
import Validation from '@/views/register/Validation.vue'
import Confirmation from '@/views/register/Confirmation.vue'
import Problem from '@/views/register/Problem.vue'

Vue.use(VueRouter)

const isLogged = (to, from, next) => {
  if (store.getters['auth/isLogged']) {
    next()
    return
  }
  next({ name: 'Login' })
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/conditions',
    name: 'Conditions',
    component: Conditions
  },
  {
    path: '/u/:code',
    name: 'QRLogin',
    component: QRLogin
  },
  {
    path: '/inscription',
    name: 'Inscription',
    component: Register,
    children: [
      {
        path: 'connexion',
        name: 'Login',
        component: Login
      },
      {
        path: 'bienvenue',
        name: 'Welcome',
        component: Welcome,
        beforeEnter: isLogged
      },
      {
        path: 'pas-moi',
        name: 'NotMe',
        component: NotMe,
        beforeEnter: isLogged
      },
      {
        path: 'etapes',
        name: 'Steps',
        component: Steps,
        beforeEnter: isLogged,
        children: [
          {
            path: 'tu-es',
            name: 'Identity',
            component: Identity,
            step: { step: 1 },
            beforeEnter: isLogged
          },
          {
            path: 'souriez',
            name: 'PhotoUpload',
            component: PhotoUpload,
            meta: { step: 2 },
            beforeEnter: isLogged
          },
          {
            path: 'ca-y-est',
            name: 'Validation',
            component: Validation,
            meta: { step: 3 },
            beforeEnter: isLogged
          }
        ]
      },
      {
        path: 'code-perdu',
        name: 'Request',
        component: Request
      },
      {
        path: 'probleme',
        name: 'Problem',
        component: Problem
      },
      {
        path: 'felicitations',
        name: 'Confirmation',
        component: Confirmation,
        beforeEnter: isLogged
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('auth/check').then(() => {
    if (to.name === 'Detail') {
      window.scrollTo(0, 0)
    }

    next()
    return
  })
})

export default router
